import styled from "styled-components";
import { DESKTOP } from "common/constants/breakpoints";

interface BubbleParentProps {
  variant: "user" | "average";
}

export default styled.div<BubbleParentProps>`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  height: 86px;
  width: 86px;
  border-radius: 50%;
  background-color: ${({ variant: type }) =>
    type === "user" ? "#a6be0a" : "#c9e034"};

  @media screen and (min-width: ${DESKTOP}px) {
    height: 172px;
    width: 172px;
  }
`;
